/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import { FormattedMessage, FormattedNumber } from 'react-intl';
import PropTypes from 'prop-types';
import React from 'react';

import Percent from '../../percent';

function RecentlySentEmail({ localizations, ...props }) {
  return (
    <li className="slds-item">
      <div className="slds-tile">
        <h3 className="slds-truncate">
          <a href={props.url} onClick={props.onClick}>
            {props.emailName}
          </a>
        </h3>
        <div className="slds-tile__detail slds-text-body--small">
          <p className="slds-text-color--weak slds-m-bottom--x-small">
            <FormattedMessage
              id="homepage.cards.sent_on"
              values={{
                sent_date: props.sendTime,
                sent_time: props.sendTime,
              }}
            />
          </p>
          <div className="slds-grid slds-grid--pull-padded">
            <div className="slds-col--padded slds-size--1-of-2">
              <div className="slds-grid slds-wrap">
                <div
                  className="slds-col slds-size--1-of-2 slds-text-color--weak slds-truncate"
                  title={localizations['homepage.cards.delivery_rate']}
                >
                  {localizations['homepage.cards.delivery_rate']}
                </div>
                <div className="slds-col slds-size--1-of-2 slds-truncate">
                  {
                    // Note: adding this check only to handle if props are not set
                    // along with linting disable until this and others can be refactored
                    isNaN(props.sent / props.delivered) ? ( // eslint-disable-line no-restricted-globals
                      <Percent value={0} />
                    ) : (
                      <Percent value={props.delivered / props.sent} />
                    )
                  }
                </div>
                <div
                  className="slds-col slds-size--1-of-2 slds-text-color--weak slds-truncate"
                  title={localizations['homepage.cards.click_rate']}
                >
                  {localizations['homepage.cards.click_rate']}
                </div>
                <div className="slds-col slds-size--1-of-2 slds-truncate">
                  <Percent value={props.uniqueClicksPercentage / 100} />
                </div>
              </div>
            </div>
            <div className="slds-col--padded slds-size--1-of-2">
              <div className="slds-grid slds-wrap">
                <div
                  className="slds-col slds-size--1-of-2 slds-text-color--weak slds-truncate"
                  title={localizations['homepage.cards.open_rate']}
                >
                  {localizations['homepage.cards.open_rate']}
                </div>
                <div className="slds-col slds-size--1-of-2 slds-truncate">
                  <Percent value={props.uniqueOpensPercentage / 100} />
                </div>
                <div
                  className="slds-col slds-size--1-of-2 slds-text-color--weak slds-truncate"
                  title={localizations['homepage.cards.audience']}
                >
                  {localizations['homepage.cards.audience']}
                </div>
                <div className="slds-col slds-size--1-of-2 slds-truncate">
                  <FormattedNumber value={props.targeted} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </li>
  );
}

RecentlySentEmail.displayName = 'Recently Sent Email';

RecentlySentEmail.propTypes = {
  delivered: PropTypes.number,
  emailName: PropTypes.string,
  localizations: PropTypes.object,
  onClick: PropTypes.func,
  sendTime: PropTypes.number,
  sent: PropTypes.number,
  targeted: PropTypes.number,
  url: PropTypes.string,
  uniqueClicksPercentage: PropTypes.string,
  uniqueOpensPercentage: PropTypes.string,
};

RecentlySentEmail.defaultProps = {
  url: 'javascript:void(0);', // eslint-disable-line no-script-url
};

export default RecentlySentEmail;
